import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  const setLang = (lng) => {
    if (lng !== i18n.language) i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`inline-flex items-center gap-1 p-1 rounded-full bg-light-grey border border-grey/20 ${className}`}
    >
      <Languages className="w-3.5 h-3.5 text-grey mx-1 shrink-0" />
      <button
        type="button"
        onClick={() => setLang("ar")}
        aria-pressed={isAr}
        className={`px-3 py-1 rounded-full text-xs font-bold transition-all duration-300 ${
          isAr
            ? "bg-gradient-to-br from-primary to-medium-blue text-white shadow-md shadow-primary/30 scale-105"
            : "text-grey hover:text-primary"
        }`}
      >
        ع
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={!isAr}
        className={`px-3 py-1 rounded-full text-xs font-bold transition-all duration-300 ${
          !isAr
            ? "bg-gradient-to-br from-primary to-medium-blue text-white shadow-md shadow-primary/30 scale-105"
            : "text-grey hover:text-primary"
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
